import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom, Subscription } from 'rxjs';
import { LabelService } from 'src/app/shared/framework/labels/services/label.service';
import iconsDataSolid from 'src/assets/icons/icons.json';
import { normalizeIconsData } from 'src/app/shared/framework/icons/icon-data';
import { LabelContext } from '../../../labels/models/LabelContext';
interface SvgIcon {
  name: string;
  svg: string;
}

@Component({
  selector: 'app-icon-select',
  templateUrl: './icon-select.component.html',
  styleUrls: ['./icon-select.component.scss'],
})
export class IconSelectComponent implements OnInit {
  private subscriptions: Subscription[] = [];
  private labelContext: LabelContext;
  private iconsSolid: { nameEN: string; nameNL: string; nameFR: string; nameDE: string; svgSafe: SafeHtml, svg: string }[] = [];

  public widgetsettings: boolean;
  public selectedIconSvg: string;
  public selectedIconType: 'customIcon' | 'customCss' | 'cssIcon';

  public selectedIcon: { nameEN: string; nameNL: string; nameFR: string; nameDE: string; svgSafe: SafeHtml, svg: string } = null;
  public filteredIcons: { nameEN: string; nameNL: string; nameFR: string; nameDE: string; svgSafe: SafeHtml, svg: string }[] = [];
  public iconSearchName: string;

  public uploadError: string | null = null;
  public uploadedImage: string | null = null;
  public isSvgFormat: boolean = false;

  @Output() iconSelected = new EventEmitter<any>();

  constructor(
    private activeModal: NgbActiveModal,
    private _toastrService: ToastrService,
    private labelService: LabelService,
    private sanitizer: DomSanitizer,
    private modalService: NgbModal
  ) { }

  async ngOnInit() {
    this.labelContext = await firstValueFrom(this.labelService.getContext('homepagesettings'));

    this.getData();

    if (this.selectedIconSvg && this.selectedIconType) {
      if (this.selectedIconType == 'customIcon') {
        this.selectedIcon = this.iconsSolid.find(icon => icon.svg === this.selectedIconSvg);
      }
      if (this.selectedIconType == 'customCss') {
        this.uploadedImage = this.selectedIconSvg;
        this.selectedIcon = null;
      }
      if (this.selectedIconType == 'cssIcon') {

        let breakException = {};
        try {
          this.iconsSolid.forEach(icon => {
            // let iconToSearch = this.selectedIconSvg.replace("fas fa-", "").replace("far fa-", "").replace("fab fa-", "").replace("fa-", "");

            if (this.selectedIconSvg.includes("fa-")) {
              this.selectedIconSvg = this.selectedIconSvg.replace("fa fa-", "fas fa-");
            }

            if (icon.nameEN == this.selectedIconSvg) {
              this.selectedIcon = icon;
              throw breakException;
            }
          })
        } catch (error) {
          if (error !== breakException) throw error;
        }
      }
    }
  }


  public showSolidIcons() {
    this.filteredIcons = this.iconsSolid;
    this.iterator();
  }

  public selectIcon(icon: any) {
    this.selectedIcon = this.selectedIcon === icon ? null : icon;
    this.uploadedImage = null;
  }

  public saveSelection(selectedIcon: { nameEN: string; nameNL: string; nameFR: string; nameDE: string; svgSafe: SafeHtml, svg: string }) {
    if (selectedIcon && selectedIcon.nameEN == this.selectedIconSvg) {
      this.activeModal.close(null);
    } else if (this.uploadedImage) {
      this.activeModal.close(this.uploadedImage);
    } else {
      this.activeModal.close(selectedIcon);
    }
  }


  public close() {
    this.activeModal.dismiss();
  }

  public iterator() {
    let searchIconName = (this.iconSearchName || '').trim().toLowerCase();

    if (searchIconName.length > 0) {
      this.filteredIcons = this.iconsSolid.filter(e =>
        (e.nameEN && e.nameEN.toLowerCase().includes(searchIconName)) ||
        (e.nameNL && e.nameNL.toLowerCase().includes(searchIconName)) ||
        (e.nameFR && e.nameFR.toLowerCase().includes(searchIconName)) ||
        (e.nameDE && e.nameDE.toLowerCase().includes(searchIconName))
      );
    } else {
      this.filteredIcons = this.iconsSolid;
    }
  }

  public onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;

    let errorWrongFile = this.labelContext.get('error_message_no_png').labelText;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const fileType = file.type;

      if (fileType !== 'image/png' && fileType !== 'image/svg+xml') {
        this.uploadError = errorWrongFile;
        this.uploadedImage = null;
        return;
      }

      this.uploadError = null;
      this.isSvgFormat = fileType === 'image/svg+xml';

      const reader = new FileReader();
      reader.onload = () => {
        if (this.isSvgFormat) {
          this.uploadedImage = reader.result as string;
        } else {
          this.uploadedImage = reader.result as string;
        }

        this.selectedIcon = null;
      };

      if (this.isSvgFormat) {
        reader.readAsText(file);
      } else {
        reader.readAsDataURL(file);
      }
    }
  }

  ngOnDestroy(): void {
    for (const subsc of this.subscriptions) {
      subsc.unsubscribe();
    }
  }

  private getData() {
    this.iconsSolid = normalizeIconsData(iconsDataSolid).map(icon => ({
      nameEN: icon.name_en,
      nameNL: icon.name_nl,
      nameFR: icon.name_fr,
      nameDE: icon.name_de,
      svgSafe: this.sanitizer.bypassSecurityTrustHtml(icon.svg),
      svg: icon.svg,
    }));
    this.showSolidIcons();
  }
}

